'use client';
import { RootState } from '@/redux/store';
import { FloatingWhatsApp } from '@repo/ui';
import { useSelector } from 'react-redux';

const Chatbot = () => {
  const isAuth = useSelector((state: RootState) => state.userdata.isAuth);
  return <FloatingWhatsApp enable={!!isAuth} />;
};

export default Chatbot;
